import { InjectionToken } from '@angular/core';
import { ISentryErrorHandlerConfig } from './interfaces/sentryErrorHandlerConfig';

export const serverUrlToken = new InjectionToken<string>('serverUrl');
export const versionToken = new InjectionToken<string>('version');
export const isUserLoggedInToken = new InjectionToken<string>('isUserLoggedIn');

export const sentryConfig = new InjectionToken<ISentryErrorHandlerConfig>('sentryConfig');
